import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  if(value >= 240) {
    return {
      title: 'คลอเลสเตอรอลสูงมาก',
      color: 'red',
      caption: 'คลอเลสเตอรอลสูงมาก',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร ควบคุมอาหารที่มีไขมัน หรือรับประทานยาลดไขมันกลุ่ม statin อย่างเคร่งครัด'
    };
  } else if(value >= 200) {
    return {
      title: 'คลอเลสเตอรอลเริ่มสูง',
      color: 'red',
      caption: 'คลอเลสเตอรอลเริ่มสูง',
      suggest: 'ปรับพฤติกรรม ควบคุมอาหารที่มีไขมัน หรือรับประทานยาลดไขมันกลุ่ม statin'
    };
  } else {
    return {
      title: 'คลอเลสเตอรอลปกติ',
      color: 'green',
      caption: 'คลอเลสเตอรอลปกติ',
      suggest: 'รับประทานยาอย่างสม่ำเสมอ รับประทานอาหาร และออกกำลังกายตามปกติ'
    };
  }
}